import { faEthereum } from '@fortawesome/free-brands-svg-icons';
import { faEur, faGbp, faUsd } from '@fortawesome/pro-solid-svg-icons';
import { FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { FiatCurrency } from '@sorare/core/src/__generated__/globalTypes';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BodyS } from '@sorare/core/src/atoms/typography';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useIntlContext } from '@sorare/core/src/contexts/intl';
import { useMonetaryAmount } from '@sorare/core/src/hooks/useMonetaryAmount';
import { MonetaryAmount } from '@sorare/core/src/lib/monetaryAmount';
import { RoundingMode } from '@sorare/core/src/lib/wei';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--intermediate-unit);
`;
const Group = styled(Horizontal)`
  background: var(--c-nd-100);
  border-radius: var(--intermediate-unit);
  padding: var(--intermediate-unit);
`;

type Props = {
  wei: bigint;
  fiat: MonetaryAmount;
};

export const MonetaryRewards = ({ wei, fiat }: Props) => {
  const { formatWei } = useIntlContext();
  const { getUserFiatAmountInMajorUnit } = useMonetaryAmount();
  const {
    fiatCurrency: { code },
  } = useCurrentUserContext();

  const amount = getUserFiatAmountInMajorUnit(fiat);

  const fiatIcon = {
    [FiatCurrency.USD]: faUsd,
    [FiatCurrency.EUR]: faEur,
    [FiatCurrency.GBP]: faGbp,
  }[code];

  return (
    <Grid>
      <Group>
        <FontAwesomeIcon icon={fiatIcon} />
        <BodyS>
          <FormattedNumber value={amount} style="currency" />
        </BodyS>
      </Group>
      <Group>
        <FontAwesomeIcon icon={faEthereum} />
        <BodyS>
          {formatWei(wei, RoundingMode.ROUND_DOWN, {}, { hideSymbol: true })}
        </BodyS>
      </Group>
    </Grid>
  );
};
